import { render, staticRenderFns } from "./CeldaSiNo.vue?vue&type=template&id=232b6b3e&scoped=true"
import script from "./CeldaSiNo.vue?vue&type=script&lang=js"
export * from "./CeldaSiNo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b6b3e",
  null
  
)

export default component.exports